export const DATA_ATTR_THEME_MODE = 'data-al-theme' as const;
export const ELEVATED_CONTAINER_CLASSNAME = 'al-elevated' as const;
export const GLOBAL_PORTAL_ELEMENT_ID = 'alchemy-portal' as const;
